<template>
  <router-view />
  <TheCssBreakpointDetector />
</template>

<script setup lang="tsx">
import { routeNames } from "@/routes";
import { TheCssBreakpointDetector, useAppNav } from "@modernary/mui/components/common";
import { useRoute } from "vue-router";

const route = useRoute();
const { setNavigationItems, setApplicationTitleComponent } = useAppNav();

const titleComponent = () => <div>AQMS</div>;
setApplicationTitleComponent(titleComponent);

// Nav items should be set one time during app initilization / config.
setNavigationItems([
  {
    label: "home",
    className: "",
    showLabel: false,
    items: [
      { label: "Home", name: routeNames.home },
      {
        label: "Organizations",
        name: routeNames.organization.organizations,
      },
      // { label: "Contacts", name: routeNames.persons },
    ],
  },
  {
    // External
    label: "Form Submissions",
    className: "",
    showLabel: false,
    items: [{ label: "Electronic Forms", name: routeNames.electronicForm.electronicForms }],
  },
  {
    // External
    label: "Complaints",
    className: "",
    showLabel: false,
    items: [{ label: "File a Complaint", name: routeNames.complaint.new }],
  },
  {
    label: "Complaints",
    className: "",
    items: [
      { label: "Complaints", name: routeNames.complaint.complaints },
      { label: "Complaint Investigations", name: routeNames.complaintInvestigation.complaintInvestigations },
      {
        label: "Complaint Enforcement Actions",
        name: routeNames.complaintEnforcementAction.complaintEnforcementActions,
      },
    ],
  },
  {
    label: "Form Submissions",
    className: "",
    items: [
      { label: "Asbestos Forms", name: routeNames.electronicForm.asbestos },
      { label: "Compliance Forms", name: routeNames.electronicForm.compliance },
      { label: "Dust Control Permitting Forms", name: routeNames.electronicForm.dustControlPermitting },
      { label: "Dust Class Registrations", name: routeNames.electronicForm.dustClass },
      { label: "Dust Monitor Class Registrations", name: routeNames.electronicForm.dustMonitorClass },
      { label: "Enforcement Forms", name: routeNames.electronicForm.enforcement },
      { label: "Open Burning Forms", name: routeNames.electronicForm.openBurning },
      { label: "Source Testing Forms", name: routeNames.electronicForm.sourceTesting },
      { label: "Stationary Source Permitting Forms", name: routeNames.electronicForm.stationarySourcePermitting },
    ],
  },
  {
    label: "Stationary Sources",
    className: "xl:break-before-column",
    items: [
      { label: "Stationary Sources", name: routeNames.stationarySource.stationarySources },
      {
        label: "Source Enforcement Actions",
        name: routeNames.stationarySourceEnforcementAction.stationarySourceEnforcementActions,
      },
    ],
  },
  {
    label: "Asbestos",
    className: "",
    items: [
      { label: "Asbestos Facilities", name: routeNames.asbestosFacility.asbestosFacilities },
      { label: "Asbestos Projects", name: routeNames.asbestosProject.asbestosProjects },
      { label: "Asbestos Notifications", name: routeNames.asbestosNotification.asbestosNotifications },
      { label: "Asbestos Inspections", name: routeNames.asbestosInspection.asbestosInspections },
      {
        label: "Asbestos Enforcement Actions",
        name: routeNames.asbestosEnforcementAction.asbestosEnforcementActions,
      },
    ],
  },
  {
    label: "Vacant Lands",
    className: "",
    items: [
      { label: "Vacant Land Parcels", name: routeNames.vacantLandParcel.vacantLandParcels },
      { label: "Vacant Land Inspections", name: routeNames.vacantLandInspection.vacantLandInspections },
      {
        label: "Vacant Land Enforcement Actions",
        name: routeNames.vacantLandEnforcementAction.vacantLandEnforcementActions,
      },
    ],
  },
  {
    label: "Dust Control",
    className: "2xl:break-before-column",
    items: [
      { label: "Construction Projects", name: routeNames.constructionProject.constructionProjects },
      {
        label: "Dust Permit Applications",
        name: routeNames.application.applications,
      },

      {
        label: "Dust Permit",
        name: routeNames.permit.permits,
      },
      { label: "Dust Inspections", name: routeNames.dustInspection.dustInspections },
      {
        label: "Dust Enforcement Actions",
        name: routeNames.dustEnforcementAction.dustEnforcementActions,
      },
    ],
  },
  {
    label: "Dust Classes",
    className: "",
    items: [
      {
        label: "Dust Classes",
        name: routeNames.dustClass.dustClasses,
      },
      {
        label: "Dust Cards",
        name: routeNames.dustCard.dustCards,
      },
    ],
  },
  {
    label: "Dust Monitor Classes",
    className: "",
    items: [
      {
        label: "Dust Monitor Classes",
        name: routeNames.dustMonitorClass.dustMonitorClasses,
      },
      {
        label: "Dust Monitor Cards",
        name: routeNames.dustMonitorCard.dustMonitorCards,
      },
    ],
  },
  {
    label: "Finance",
    className: "3xl:break-before-column",
    items: [
      {
        label: "Invoices",
        name: routeNames.invoice.invoices,
      },
    ],
  },

  // Add routes to ./routes.tsx
  // In order to authorize route, must add policy to PolicyAccessConrols at Name: [AQMS2:Navigation Policy Access Controls]
  {
    label: "Temporary",
    className: "",
    items: [
      {
        label: "Organizations",
        name: routeNames.organization.organizations,
      },

      {
        label: "Invoices",
        name: routeNames.invoice.invoices,
      },
      {
        label: "Users",
        name: routeNames.user.users,
      },
    ],
  },
]);
</script>
